import clsx from 'clsx';
import { Suspense } from 'react';
import { AppVersionUpdater } from '@/components/app-version-updater/app-version-updater';
import { TermsAcceptance } from '@/components/terms-acceptance/terms-acceptance';
import { NotificationsSubscription } from '@/routes/_app.p.notifications._index/notifications-subscription';
import { usePullToRefreshIos } from '@/utils/use-pull-to-refresh-ios.tsx';
import { useReadPushNotifications } from '@/utils/use-read-push-notifications.ts';
import { BootIntercom } from './boot-intercom';
import { useAppLoader } from './loader';
import { MainContent } from './main-content/main-content';
import { NotificationFaviconUpdater } from './notification-favicon-updater';
import { Sidebar } from './sidebar/sidebar';
import { useSidebarContext } from './sidebar/sidebar-context';
import { root, rootVariants, rootWithSidebarCollapsed } from './layout.css';

const AuthenticatedContent = () => {
  usePullToRefreshIos();
  useReadPushNotifications();

  return (
    <>
      <Sidebar />
      <MainContent />
      <NotificationsSubscription />
      <Suspense fallback={null}>
        <NotificationFaviconUpdater />
      </Suspense>
      <Suspense fallback={null}>
        <TermsAcceptance />
      </Suspense>
    </>
  );
};

export const AppContent = () => {
  const { authenticated } = useAppLoader();
  const { isCollapsed } = useSidebarContext();

  return (
    <div
      className={clsx(
        root,
        {
          [rootWithSidebarCollapsed]: isCollapsed,
        },
        rootVariants.protected,
      )}
    >
      {authenticated ? (
        <AuthenticatedContent />
      ) : (
        <>
          <Sidebar />
          <MainContent />
        </>
      )}

      <BootIntercom />

      <AppVersionUpdater />
    </div>
  );
};
